export const no = {
  "account": {
    "k1": "Startpakke",
    "k2": "Få 125 kreditter. Perfekt for å komme i gang og teste kjernefunksjonaliteten.",
    "k3": "Pro-pakke",
    "k4": "Få 250 kreditter. Det beste valget for regelmessige brukere.",
    "k5": "Bedriftspakke",
    "k6": "Få 1700 kreditter. For superbrukere og virksomheter, med 25 % rabatt.",
    "k7": "Enterprise-pakke",
    "k8": "Få 5000 kreditter. Den ultimate pakken for institusjonelle klienter, med en betydelig rabatt på 50 %.",
    "k9": "Laster inn kontodetaljer...",
    "k10": "Kontoadministrasjon",
    "k11": "Nåværende kreditter",
    "k12": "Nye brukere mottar 125 kreditter, til en verdi av $50, for å komme i gang!",
    "k13": "Du har lite kreditter igjen. Kjøp flere for å fortsette å bruke AI-funksjonene uten avbrudd.",
    "k14": "Har du en kupongkode?",
    "k15": "Løs inn kode",
    "k16": "Kjøp flere kreditter",
    "k17": "Kjøp nå"
  },
  "aIChatWindow": {
    "k1": "Veksle AI-assistent",
    "k2": "AI-assistent",
    "k3": "Spør om porteføljen din",
    "k4": "Hvordan kan jeg hjelpe deg i dag?",
    "k5": "Still et spørsmål..."
  },
  "allActivities": {
    "k1": "Laster inn aktiviteter...",
    "k2": "Fullstendig logg over kredittbruk",
    "k3": "Ingen aktiviteter å vise."
  },
  "auth": {
    "k1": "CRE Dominion",
    "k2": "Opprett konto",
    "k3": "Velkommen tilbake",
    "k4": "Registrer deg for å komme i gang",
    "k5": "Logg inn på kontoen din",
    "k6": "E-postadresse",
    "k7": "Passord",
    "k8": "Eller fortsett med",
    "k9": "Google",
    "k10": "Har du allerede en konto? Logg inn",
    "k11": "Har du ikke en konto? Registrer deg"
  },
  "bulkLeaseUploader": {
    "k1": "Laster inn eiendommer...",
    "k2": "Feil:",
    "k3": "Leiekontrakt-opplaster",
    "k4": "Eiendom (påkrevd):",
    "k5": "Velg en eiendom",
    "k6": "Ingen eiendommer funnet. Vennligst legg til en eiendom først.",
    "k7": "Last opp filer",
    "k8": "Last opp mappe",
    "k9": "Velg leiekontrakter (PDF-er, bilder):",
    "k10": "Velg mappe med leiekontrakter (laster opp alle PDF-er/bilder):",
    "k11": "Last opp leiekontrakter",
    "k12": "Valgt",
    "k13": "fil",
    "k14": "Historikk for opplastede leiekontrakter",
    "k15": "Laster inn historikk...",
    "k16": "Ingen opplastingshistorikk funnet.",
    "k17": "Jobb-ID",
    "k18": "Opplastet tidspunkt",
    "k19": "Antall filer",
    "k20": "Status",
    "k21": "Handlinger",
    "k22": "Vis"
  },
  "bulkLeaseValidator": {
    "k1": "Laster inn bulk-valideringsjobb...",
    "k2": "Laster opp filer... Denne prosessen kan ta tid avhengig av antall og størrelse på dokumentene. Du kan trygt navigere bort; prosessen fortsetter i bakgrunnen.",
    "k3": "Ingen poster funnet for denne jobb-ID-en.",
    "k4": "Bulk-validering av leiekontrakter (Jobb-ID:",
    "k5": "Tilbake til leiekontrakt-opplaster",
    "k6": "Godkjenner valgte...",
    "k7": "Godkjenn valgte leiekontrakter",
    "k8": "Godkjenner alle...",
    "k9": "Godkjenn alle ventende leiekontrakter",
    "k10": "Filnavn",
    "k11": "Status",
    "k12": "Handlinger",
    "k13": "Feil:"
  },
  "calendarEventModal": {
    "k1": "Type:",
    "k2": "Start:",
    "k3": "Slutt:",
    "k4": "Eiendoms-ID:",
    "k5": "System-leie-ID:",
    "k6": "Egendefinert leie-ID:",
    "k7": "Hendelses-ID:",
    "k8": "Lukk"
  },
  "calendarView": {
    "k1": "Laster inn kalender...",
    "k2": "Feil:",
    "k3": "Kalender for kritiske datoer"
  },
  "calendarViewWrapper": {
    "k1": "Kalender"
  },
  "dashboard": {
    "k1": "Dashbord-oversikt",
    "k2": "Feil:",
    "k3": "Ingen dashborddata tilgjengelig.",
    "k4": "Totalt antall eiendommer",
    "k5": "Totalt antall leietakere",
    "k6": "Totalt antall leiekontrakter",
    "k7": "Utløpende leiekontrakter",
    "k8": "Eiendomsbelegg",
    "k9": "Eiendomstyper",
    "k10": "Trender for ledighetsrate"
  },
  "dealSourcing": {
    "k1": "Laster inn avtaler...",
    "k2": "Feil:",
    "k3": "Avtaleinnhenting og -håndtering",
    "k4": "Rediger transaksjon",
    "k5": "Legg til ny transaksjon",
    "k6": "Transaksjonsnavn",
    "k7": "Velg transaksjonstype",
    "k8": "Oppkjøp",
    "k9": "Avhending",
    "k10": "Utvikling",
    "k11": "Velg status",
    "k12": "Pipeline",
    "k13": "Due Diligence",
    "k14": "Avsluttet",
    "k15": "Tapt",
    "k16": "Tilknytt eiendom (valgfritt)",
    "k17": "Målpris",
    "k18": "Budpris",
    "k19": "Sluttdato:",
    "k20": "Kilde",
    "k21": "Beskrivelse",
    "k22": "Oppdater transaksjon",
    "k23": "Legg til transaksjon",
    "k24": "Avbryt redigering",
    "k25": "Mine transaksjoner",
    "k26": "Ingen transaksjoner funnet. Legg til en ovenfor!",
    "k27": "Status:",
    "k28": "Eiendom:",
    "k29": "Målpris:",
    "k30": "Budpris:",
    "k31": "Kilde:",
    "k32": "Beskrivelse:",
    "k33": "Rediger",
    "k34": "Slett"
  },
  "documents": {
    "k1": "Laster inn dokumenter...",
    "k2": "Feil:",
    "k3": "Dokumenthåndtering",
    "k4": "Last opp nytt dokument",
    "k5": "Eiendom (obligatorisk):",
    "k6": "Velg eiendom",
    "k7": "Velg dokument(er):",
    "k8": "Last opp dokument(er)",
    "k9": "Dine dokumenter",
    "k10": "Ingen dokumenter funnet. Last opp et dokument ovenfor!",
    "k11": "Type:",
    "k12": "Eiendoms-ID:",
    "k13": "Beskrivelse:",
    "k14": "Opplastet:",
    "k15": "Vis",
    "k16": "Rediger",
    "k17": "Slett"
  },
  "editCompModal": {
    "k1": "Rediger sammenlignbart salg",
    "k2": "Adresse:",
    "k3": "Salgsdato:",
    "k4": "Salgspris:",
    "k5": "Areal (kvadratfot):",
    "k6": "Avbryt",
    "k7": "Lagre endringer"
  },
  "editDocumentModal": {
    "k1": "Rediger dokument",
    "k2": "Filnavn:",
    "k3": "Beskrivelse:",
    "k4": "Avbryt",
    "k5": "Lagre endringer"
  },
  "editLeaseModal": {
    "k1": "Rediger leiekontrakt",
    "k2": "Egendefinert leie-ID:",
    "k3": "Leietakernavn:",
    "k4": "Startdato:",
    "k5": "Sluttdato:",
    "k6": "Leiebeløp:",
    "k7": "Avbryt",
    "k8": "Lagre endringer"
  },
  "editTransactionModal": {
    "k1": "Rediger transaksjon",
    "k2": "Type:",
    "k3": "Beskrivelse:",
    "k4": "Beløp:",
    "k5": "Forfallsdato:",
    "k6": "Betalingsdato:",
    "k7": "Kategori:",
    "k8": "Inntekt",
    "k9": "Utgift",
    "k10": "Avbryt",
    "k11": "Lagre endringer"
  },
  "fAQ": {
    "k1": "Hva er CRE Dominion?",
    "k2": "CRE Dominion er en omfattende, AI-drevet plattform utviklet for profesjonelle aktører innen næringseiendom (CRE). Den effektiviserer eiendomsforvaltning, transaksjonsinnhenting, leieavtaleabstraksjon, markedsanalyse og mer, slik at du kan ta datadrevne beslutninger for å bygge din eiendomsportefølje.",
    "k3": "Hvem er CRE Dominion for?",
    "k4": "CRE Dominion er bygget for et bredt spekter av CRE-profesjonelle, inkludert eiendomseiere, forvaltere, asset managers, meglere og investorer. Enten du forvalter en enkelt eiendom eller en stor portefølje, gir plattformen vår verktøyene du trenger for å lykkes.",
    "k5": "Hva er nøkkelfunksjonene i CRE Dominion?",
    "k6": "Våre nøkkelfunksjoner inkluderer AI-drevet leieavtaleabstraksjon, avansert transaksjonsinnhenting og analyse, omfattende eiendoms- og leietakerforvaltning, markedsanalyse og prediktive trender, verdivurdering av eiendom, tilpassbar rapportering og sikker dokumenthåndtering.",
    "k7": "Hvordan fungerer funksjonen for leieavtaleabstraksjon?",
    "k8": "Vårt AI-drevne verktøy for leieavtaleabstraksjon henter automatisk ut nøkkelinformasjon fra dine leiekontrakter, som start- og sluttdatoer, leiebeløp, klausuler og mer. Dette sparer deg for utallige timer med manuelt dataarbeid og reduserer risikoen for feil.",
    "k9": "Er dataene mine sikre?",
    "k10": "Ja, datasikkerhet er vår høyeste prioritet. Vi benytter bransjeledende sikkerhetstiltak, inkludert kryptering og sikker skylagring, for å beskytte din sensitive informasjon. Dine data er trygge, sikre og alltid tilgjengelige for deg.",
    "k11": "Hvilke typer eiendommer kan jeg forvalte med CRE Dominion?",
    "k12": "Du kan forvalte et bredt utvalg av næringseiendommer, inkludert kontorbygg, næringslokaler for detaljhandel, industrieiendommer og boligbygg med flere enheter.",
    "k13": "Hvordan fungerer funksjonen for transaksjonsinnhenting?",
    "k14": "Vår modul for transaksjonsinnhenting bruker avanserte algoritmer og markedsdata for å hjelpe deg med å identifisere og evaluere potensielle investeringsmuligheter som samsvarer med dine kriterier. Du kan analysere transaksjoner, utføre due diligence og spore din pipeline på ett og samme sted.",
    "k15": "Kan jeg generere tilpassede rapporter?",
    "k16": "Ja, plattformen vår inkluderer en kraftig rapportmotor som lar deg generere et bredt spekter av tilpassbare rapporter om porteføljeytelse, finansielle nøkkeltall, leieaktivitet og mer. Disse rapportene kan skreddersys for å møte behovene til dine interessenter.",
    "k17": "Hva er prismodellen?",
    "k18": "CRE Dominion opererer med et fleksibelt kredittbasert system. Du kjøper kreditter som benyttes for tilgang til ulike AI-drevne funksjoner og avansert analyse. Dette sikrer at du kun betaler for det faktiske forbruket, og at løsningen skalerer i takt med dine spesifikke behov. Besøk kontoinnstillingene dine for alternativer for kredittkjøp og detaljer om forbruk.",
    "k19": "Hvordan kommer jeg i gang?",
    "k20": "Det er enkelt å komme i gang! Du kan registrere deg for en gratis prøveperiode direkte via nettsiden vår. Etter registrering kan du umiddelbart begynne å legge til eiendommer og utforske plattformens funksjonalitet.",
    "k21": "&larr; Tilbake til forsiden",
    "k22": "Ofte stilte spørsmål"
  },
  "financialsLedger": {
    "k1": "Laster inn finansielle data...",
    "k2": "Feil:",
    "k3": "Inntekter",
    "k4": "Utgifter",
    "k5": "Ingen",
    "k6": "poster funnet.",
    "k7": "Type",
    "k8": "Beskrivelse",
    "k9": "Beløp",
    "k10": "Forfallsdato",
    "k11": "Betalingsdato",
    "k12": "Handlinger",
    "k13": "Rediger",
    "k14": "Slett",
    "k15": "Legg til ny finansiell transaksjon",
    "k16": "Kategori",
    "k17": "Utgift",
    "k18": "Transaksjonstype",
    "k19": "Legg til transaksjon",
    "k20": "Finansiell oversikt"
  },
  "homePage": {
    "k1": "Starter Pack",
    "k2": "Perfekt for innledende screening av transaksjoner og utprøving av AI-basert leieavtaleabstraksjon.",
    "k3": "Pro Pack",
    "k4": "Optimalt for aktive oppkjøpsteam, meglere og kapitalforvaltere.",
    "k5": "Business Pack",
    "k6": "For boutique-fond, familieformuesforvaltning (family offices) og oppkjøpspipelines med høyt volum.",
    "k7": "Enterprise Pack",
    "k8": "Institusjonell skala for REIT-er, gjeldsfond og store porteføljer.",
    "k9": "CRE Dominion | AI-drevet plattform for næringseiendom, underwriting og leieavtalehåndtering",
    "k10": "CRE Dominion-logo",
    "k11": "Live Screener",
    "k12": "Priser",
    "k13": "Kunnskapsbase",
    "k14": "Kontakt",
    "k15": "Logg inn",
    "k16": "Institusjonell underwriting for næringseiendom",
    "k17": "På 10 sekunder. Ingen regneark.",
    "k18": "Slutt å tape avtaler på grunn av treg manuell due diligence. CRE Dominion kombinerer automatisert AI-leieavtaleabstraksjon med institusjonell finansiell modellering på tvers av amerikanske Cap Rates, britiske Net Initial Yields og europeiske metriske standarder.",
    "k19": "Start Live Deal Screener ↓",
    "k20": "Kom i gang gratis (125 kreditter)",
    "k21": "Ingen kredittkort kreves",
    "k22": "Kompatibel med USA, UK og Norden/EU",
    "k23": "125 gratis startkreditter",
    "k24": "Automatisering av institusjonelle arbeidsflyter",
    "k25": "Hele din kommersielle arbeidsflyt, samlet i én plattform.",
    "k26": "Utviklet fra grunnen av for oppkjøpsansvarlige, meglere og private equity-aktører som krever hastighet uten å ofre revisjonsmessig presisjon.",
    "k27": "10-sekunders AI-leieavtaleabstraksjon",
    "k28": "Ekstraher nøkkeldatoer, leiejusteringer, oppsigelsesopsjoner, forsikringsforpliktelser og leietakerklausuler fra 80-siders kontrakter på sekunder med 99,9 % nøyaktighet.",
    "k29": "Finansiell modellering på tvers av jurisdiksjoner",
    "k30": "Innebygd modellering for amerikanske Triple Net (NNN) Cap Rates, britiske Full Repairing &amp; Insuring (FRI) Net Initial Yields, og nordiske/europeiske metriske leieavtaler (`m²`).",
    "k31": "AI-drevet avtaleinnhenting og pipeline",
    "k32": "Sentraliser potensielle oppkjøp, spor budfrister, administrer underwriting-status og generer investor-klare teasere i en enhetlig pipeline.",
    "k33": "Prediktiv markedsanalyse",
    "k34": "Prognostiser Cap Rate-utvikling, vakanstrender og leievekst i delmarkeder ved bruk av historisk telemetri og sanntidsdata for sammenlignbare salg.",
    "k35": "Umiddelbar verdivurdering og DCF-scenarioer",
    "k36": "Kjør discounted cash flow (DCF), direkte kapitalisering og sammenlignbare salgsmodeller side om side for å stressteste din exit Cap Rate og lånefinansierte avkastning.",
    "k37": "Enterprise Vault og SOC-sikkerhet",
    "k38": "Isolert Google Cloud-lagring med streng IAM-autorisasjon. Dine proprietære leieoversikter, T-12-rapporter og leieavtaler blir aldri delt eller matet inn i offentlige LLM-er.",
    "k39": "Interaktiv live-demo",
    "k40": "Test vår AI-leiekontraktmotor på enhver klausul",
    "k41": "Lim inn en leieklausul (skadesløsholdelse, oppsigelsesrett, KPI-regulering, medleie) eller last opp en 1-sides avtale nedenfor. Få en umiddelbar risikoscore og analyse av forhandlingspunkter.",
    "k42": "Transparent suveren prising",
    "k43": "Betal kun for det du analyserer.",
    "k44": "Ingen obligatoriske årlige kontrakter på $5 000 per bruker. Ingen salgsdemoer. Kom i gang umiddelbart med 125 gratis startkreditter ved registrering, og fyll på etter hvert som porteføljen vokser.",
    "k45": "Mest populær",
    "k46": "engangs",
    "k47": "Ca.",
    "k48": "Analysekreditter",
    "k49": "Kom i gang →",
    "k50": "Trenger du tilpasset bedriftsvolum, lokal distribusjon (on-premise) eller dedikerte API-kvoter? Kontakt vårt ingeniørteam på",
    "k51": "Slutt å la penger ligge på bordet.",
    "k52": "Bli med CRE-profesjonelle som bruker AI til å automatisere abstraksjon, finne off-market-avtaler og maksimere porteføljens ROI i USA, Storbritannia og Europa.",
    "k53": "Kom i gang gratis →",
    "k54": "Test avtalescreening",
    "k55": "Ingen kredittkort kreves • Umiddelbar kontoopprettelse med 125 gratis kreditter",
    "k56": "Høypresisjons operativsystem for næringseiendom. Automatisert AI-leieabstraksjon, underwriting-modellering og porteføljeinnsikt.",
    "k57": "&copy;",
    "k58": "CRE Dominion. Alle rettigheter reservert.",
    "k59": "Facebook",
    "k60": "Instagram",
    "k61": "LinkedIn",
    "k62": "Google Play",
    "k63": "Personvernerklæring",
    "k64": "Tjenestevilkår",
    "k65": "FAQ"
  },
  "kPISection": {
    "k1": "Se detaljer"
  },
  "leaseAbstraction": {
    "k1": "Leieabstraksjon",
    "k2": "Velg eiendom:",
    "k3": "-- Velg en eiendom --",
    "k4": "Last opp leiedokument (PDF, PNG, JPG):",
    "k5": "Last opp og abstraher",
    "k6": "Ekstraherte leiekontrakter",
    "k7": "Leiekontrakt-ID:",
    "k8": "Status:",
    "k9": "Ekstraherte leiedata (ID:",
    "k10": "Godkjenn leiekontrakt",
    "k11": "Rediger leiekontrakt",
    "k12": "Slett leiekontrakt",
    "k13": "Lagre endringer",
    "k14": "Avbryt",
    "k15": "Eiendoms-ID:",
    "k16": "Dokument-URL:",
    "k17": "Vis dokument",
    "k18": "AI-ekstraherte data:",
    "k19": "Leiestart:",
    "k20": "Leieslutt:",
    "k21": "Månedsleie:",
    "k22": "Depositum:",
    "k23": "Leietakers navn:",
    "k24": "Utleiers navn:",
    "k25": "Eiendomsadresse:",
    "k26": "Ingen spesifikke data ekstrahert.",
    "k27": "Fullstendig ekstrahert tekst:"
  },
  "leaseAbstractionSettings": {
    "k1": "Laster inn innstillinger for leieabstraksjon...",
    "k2": "Innstillinger for leieabstraksjon",
    "k3": "Velg forhåndsdefinerte klausuler:",
    "k4": "Annet (spesifiser nedenfor)",
    "k5": "Egendefinerte klausuler (kommadelt):",
    "k6": "f.eks. klausul om førtidig oppsigelse, fremleierett",
    "k7": "Lagre leieklausuler"
  },
  "leaseExpirationChart": {
    "k1": "Antall utløpende leiekontrakter",
    "k2": "Leieutløp per måned",
    "k3": "Antall leiekontrakter"
  },
  "leases": {
    "k1": "Feil:",
    "k2": "Leiekontrakter",
    "k3": "Avbryt ny leiekontrakt",
    "k4": "Legg til ny leiekontrakt",
    "k5": "Opplasting av leiekontrakt",
    "k6": "Abstraksjon av leiekontrakt",
    "k7": "Eiendoms-ID:",
    "k8": "Velg eiendom",
    "k9": "Egendefinert leie-ID (valgfritt):",
    "k10": "Egendefinert leie-ID",
    "k11": "Leietaker:",
    "k12": "Velg leietaker",
    "k13": "Startdato for leieforhold:",
    "k14": "Sluttdato for leieforhold:",
    "k15": "Månedsleie:",
    "k16": "Månedsleie",
    "k17": "Leietype:",
    "k18": "Leietype",
    "k19": "Leieperiode (måneder):",
    "k20": "Leieperiode (måneder)",
    "k21": "Status:",
    "k22": "Aktiv",
    "k23": "Venter på vurdering",
    "k24": "Utløpt",
    "k25": "Opphørt",
    "k26": "Notater",
    "k27": "Opprett leiekontrakt",
    "k28": "Avbryt",
    "k29": "Rediger leiekontrakt (ID:",
    "k30": "Eiendom:",
    "k31": "Velg leietaker (valgfritt)",
    "k32": "Oppdater leiekontrakt",
    "k33": "Ingen leiekontrakter funnet",
    "k34": "Leiekontrakt:",
    "k35": "System-ID:",
    "k36": "Utleier:",
    "k37": "Leieperiode:",
    "k38": "til",
    "k39": "Leiepris:",
    "k40": "Depositum:",
    "k41": "Rediger",
    "k42": "Slett",
    "k43": "Vis dokument",
    "k44": "Rådata",
    "k45": "Råekstraherte data",
    "k46": "Lukk",
    "k47": "Slett leiekontrakt"
  },
  "marketAnalysis": {
    "k1": "&larr; Tilbake til eiendommer",
    "k2": "Markedsanalyse",
    "k3": "Henter analyse...",
    "k4": "Hent markedsanalyse",
    "k5": "Lagre resultat",
    "k6": "Laster analyse...",
    "k7": "Markedsanalyse for eiendom",
    "k8": "Detaljer om objektet",
    "k9": "Adresse:",
    "k10": "Eiendomstype:",
    "k11": "Areal (kvm):",
    "k12": "Sammenlignbare markedsdata",
    "k13": "Antall sammenlignbare eiendommer funnet:",
    "k14": "Gjennomsnittspris per kvm (sammenlignbare):",
    "k15": "Gjennomsnittlig salgspris (sammenlignbare):",
    "k16": "Gjennomsnittlig areal (sammenlignbare):",
    "k17": "Markedskommentar:",
    "k18": "Sammendrag:",
    "k19": "Viktige trender:",
    "k20": "Anbefaling:"
  },
  "marketComps": {
    "k1": "Laster markedsreferanser...",
    "k2": "Feil:",
    "k3": "Legg til nytt sammenlignbart salg",
    "k4": "Adresse",
    "k5": "Salgsdato",
    "k6": "Salgspris",
    "k7": "Areal (kvm)",
    "k8": "Legg til referanse",
    "k9": "Markedsreferanser",
    "k10": "Ingen markedsreferanser tilgjengelig.",
    "k11": "Pris/kvm",
    "k12": "Handlinger",
    "k13": "Rediger",
    "k14": "Slett"
  },
  "navbar": {
    "k1": "CRE Dominion",
    "k2": "Kjerne",
    "k3": "Dashbord",
    "k4": "Eiendommer",
    "k5": "Leietakere",
    "k6": "Leiekontrakter",
    "k7": "Dokumenter",
    "k8": "Leieabstraksjon",
    "k9": "Opplasting av leiekontrakt",
    "k10": "Vekst",
    "k11": "Deal Sourcing",
    "k12": "Underwriting",
    "k13": "Konto",
    "k14": "Logg ut"
  },
  "occupancyChart": {
    "k1": "Utleiegrad",
    "k2": "Nåværende utleiegrad",
    "k3": "Prosentandel (%)"
  },
  "overduePaymentsSection": {
    "k1": "Forfalte betalinger",
    "k2": "Forfalt fra:",
    "k3": "Leieavtale-ID:",
    "k4": "Ingen forfalte betalinger."
  },
  "predictiveTrends": {
    "k1": "&larr; Tilbake til eiendommer",
    "k2": "Prediktive trender",
    "k3": "Oppgi en eiendoms-ID...",
    "k4": "Henter trender...",
    "k5": "Hent prediktive trender",
    "k6": "Lagre resultat",
    "k7": "Trendprediksjon for eiendom",
    "k8": "Måldato:",
    "k9": "Predikert verdi:",
    "k10": "Konfidensskåre:",
    "k11": "Begrunnelse:",
    "k12": "Feil:",
    "k13": "Rårespons:"
  },
  "privacyPolicy": {
    "k1": "&larr; Tilbake til forsiden",
    "k2": "Personvernerklæring for CRE Dominion",
    "k3": "Denne personvernerklæringen beskriver hvordan CRE Dominion («vi», «oss» eller «vår») samler inn, bruker og utleverer din informasjon når du benytter vår webapplikasjon («Tjenesten»). Vi er forpliktet til å beskytte ditt personvern og håndtere dine data på en åpen og transparent måte.",
    "k4": "Datainnsamling og bruk",
    "k5": "Vi samler inn ulike typer informasjon for å levere og forbedre vår Tjeneste til deg. Når du logger inn med Google, samler vi inn personopplysninger som navn og e-postadresse fra din Google-konto. Denne informasjonen brukes til å opprette og administrere din brukerkonto i CRE Dominion, samt for å tilpasse din brukeropplevelse. Etter hvert som du bruker Tjenesten, kan du gi oss ytterligere data, inkludert eiendomsdetaljer, leieavtaler, leietakeropplysninger og andre eiendomsrelaterte data. Dette brukergenererte innholdet lagres og behandles for å levere Tjenestens kjernefunksjonalitet, som leieavtaleabstraksjon, eiendomsforvaltning og markedsanalyse. Vi samler også inn bruksdata, som kan inkludere informasjon som din datamaskins IP-adresse, nettlesertype, nettleserversjon, hvilke sider i vår Tjeneste du besøker, tidspunkt og dato for besøket, tiden brukt på disse sidene, unike enhetsidentifikatorer og andre diagnostiske data. Disse dataene hjelper oss å forstå hvordan vår Tjeneste brukes, og gjør oss i stand til å forbedre ytelsen og funksjonaliteten.",
    "k6": "Datalagring og behandling",
    "k7": "Dine data, inkludert personopplysninger og brukergenerert innhold, lagres og behandles ved bruk av Google Clouds økosystem, inkludert Google Cloud SQL for databasehåndtering, Google Cloud Storage for dokumentlagring, samt Google Clouds Vertex AI og Gemini for avansert analyse og maskinlæringsfunksjonalitet som leieavtaleabstraksjon og trendprediksjon. Vi sikrer at egnede sikkerhetstiltak er på plass for å beskytte dine data når de behandles av disse tjenestene.",
    "k8": "Informasjonskapsler (cookies) og sporingsteknologi",
    "k9": "Vi bruker informasjonskapsler og lignende sporingsteknologi for å overvåke aktivitet på vår Tjeneste og lagre viss informasjon. Informasjonskapsler er filer med en liten mengde data som sendes til din nettleser fra et nettsted og lagres på din enhet. Sporingsteknologi som også benyttes er beacons, tags og skript for å samle inn og spore informasjon, samt for å forbedre og analysere vår Tjeneste. Du kan instruere nettleseren din til å avvise alle informasjonskapsler eller indikere når en informasjonskapsel sendes. Dersom du ikke aksepterer informasjonskapsler, kan det imidlertid hende at enkelte deler av vår Tjeneste ikke er tilgjengelige.",
    "k10": "Datadeling og utlevering",
    "k11": "Vi selger ikke dine personopplysninger. Vi kan dele din informasjon med tredjeparts tjenesteleverandører for å fasilitere vår Tjeneste, levere Tjenesten på våre vegne, utføre tjenester knyttet til Tjenesten, eller bistå oss i analysen av hvordan vår Tjeneste brukes. Disse tredjepartene har kun tilgang til dine personopplysninger for å utføre disse oppgavene på våre vegne, og er forpliktet til ikke å utlevere eller bruke dem til andre formål. Vi kan også utlevere dine personopplysninger i god tro om at slik handling er nødvendig for å overholde en rettslig forpliktelse, beskytte og forsvare rettighetene eller eiendommen til CRE Dominion, forhindre eller etterforske mulige misligheter knyttet til Tjenesten, beskytte den personlige sikkerheten til brukere av Tjenesten eller allmennheten, eller beskytte mot rettslig ansvar.",
    "k12": "Lagring av data",
    "k13": "Vi oppbevarer dine personopplysninger kun så lenge det er nødvendig for formålene angitt i denne personvernerklæringen. Vi vil oppbevare og bruke dine personopplysninger i den grad det er nødvendig for å overholde våre juridiske forpliktelser, løse tvister og håndheve våre juridiske avtaler og retningslinjer.",
    "k14": "Dine rettigheter knyttet til personvern",
    "k15": "Avhengig av hvor du befinner deg, kan du ha følgende rettigheter knyttet til personvern: rett til innsyn, oppdatering eller sletting av informasjonen vi har om deg; rett til retting; rett til innsigelse; rett til begrensning; rett til dataportabilitet; og rett til å trekke tilbake samtykke. For å utøve noen av disse rettighetene, vennligst kontakt oss ved å bruke informasjonen nedenfor.",
    "k16": "Forespørsler om sletting av konto og data",
    "k17": "Merknad om samsvar med sletting av data for Google Play:",
    "k18": "CRE Dominion gir brukere full kontroll over sin konto og sine personopplysninger. Du har rett til å be om sletting av din konto og alle tilhørende personopplysninger når som helst.",
    "k19": "Slik ber du om sletting av konto og data:",
    "k20": "Send en e-post til",
    "k21": "med emnefeltet",
    "k22": "\"Account Deletion Request\"",
    "k23": "Inkluder den registrerte e-postadressen tilknyttet din CRE Dominion-konto.",
    "k24": "Vårt supportteam vil behandle din sletteforespørsel innen 7 virkedager og bekrefte når prosessen er fullført.",
    "k25": "Data som vil bli permanent slettet:",
    "k26": "Kontoverifiseringsdetaljer (e-post, navn, profilinformasjon, UID).",
    "k27": "Opplastede leiekontrakter, PDF-filer og lagret innhold i dokumenthvelvet.",
    "k28": "Lagrede eiendomsprofiler, leietakerlister og finansielle verdivurderingsrapporter.",
    "k29": "Unntak for datalagring:",
    "k30": "Visse anonymiserte systemlogger eller transaksjonsbilag kan oppbevares midlertidig for å overholde juridiske forpliktelser, finansielle revisjoner eller krav om forebygging av svindel i henhold til gjeldende lovverk.",
    "k31": "Personvern for barn",
    "k32": "Vår tjeneste er ikke beregnet for bruk av barn under 13 år (\"Barn\"). Vi samler ikke bevisst inn personopplysninger fra personer under 13 år. Hvis du er forelder eller foresatt og er klar over at ditt barn har gitt oss personopplysninger, vennligst kontakt oss. Hvis vi blir oppmerksomme på at vi har samlet inn personopplysninger fra barn uten verifisert foreldresamtykke, tar vi skritt for å fjerne denne informasjonen fra våre servere.",
    "k33": "Endringer i denne personvernerklæringen",
    "k34": "Vi kan oppdatere vår personvernerklæring fra tid til annen. Vi vil varsle deg om eventuelle endringer ved å publisere den nye personvernerklæringen på denne siden. Du anbefales å gjennomgå denne personvernerklæringen med jevne mellomrom for eventuelle endringer. Endringer i denne personvernerklæringen trer i kraft når de publiseres på denne siden.",
    "k35": "Kontakt oss",
    "k36": "Hvis du har spørsmål om denne personvernerklæringen eller ønsker å be om sletting av data, vennligst kontakt oss på support@credominion.com."
  },
  "properties": {
    "k1": "Feil:",
    "k2": "Eiendommer",
    "k3": "Rediger eiendom",
    "k4": "Legg til ny eiendom",
    "k5": "Auto-hent fra OM",
    "k6": "System-ID:",
    "k7": "Adresse",
    "k8": "By",
    "k9": "Delstat",
    "k10": "Postnummer",
    "k11": "Eiendoms-type",
    "k12": "Eiendoms-ID (valgfri)",
    "k13": "Areal (kvadratfot)",
    "k14": "Antall enheter",
    "k15": "Kjøpesum",
    "k16": "Nåværende verdi",
    "k17": "Byggeår",
    "k18": "Beskrivelse",
    "k19": "Oppdater eiendom",
    "k20": "Legg til eiendom",
    "k21": "Avbryt redigering",
    "k22": "Dine eiendommer",
    "k23": "Ingen eiendommer funnet",
    "k24": "Type:",
    "k25": "Størrelse:",
    "k26": "kvadratfot",
    "k27": "Enheter:",
    "k28": "Kjøpesum:",
    "k29": "Nåværende verdi:",
    "k30": "Byggeår:",
    "k31": "Beskrivelse:",
    "k32": "Rediger",
    "k33": "Slett",
    "k34": "Markedsanalyse",
    "k35": "Verdivurdering",
    "k36": "Prediktive trender",
    "k37": "Slett eiendom"
  },
  "propertyDetailView": {
    "k1": "Laster eiendomsdetaljer...",
    "k2": "Feil:",
    "k3": "&larr; Tilbake til eiendommer",
    "k4": "Eiendom-ID:",
    "k5": "Eiendom-ID",
    "k6": "System-ID",
    "k7": "Eiendomsype",
    "k8": "Areal (kvadratfot)",
    "k9": "kvadratfot",
    "k10": "Antall enheter",
    "k11": "Kjøpesum",
    "k12": "Nåværende verdi",
    "k13": "Byggeår",
    "k14": "Beskrivelse"
  },
  "propertyDocuments": {
    "k1": "Laster inn dokumenter...",
    "k2": "Feil:",
    "k3": "Eiendomsdokumenter",
    "k4": "Ingen dokumenter funnet for denne eiendommen.",
    "k5": "Type:",
    "k6": "Beskrivelse:",
    "k7": "Opplastet:",
    "k8": "Vis",
    "k9": "Rediger",
    "k10": "Slett"
  },
  "propertyInsights": {
    "k1": "Vis mindre",
    "k2": "Vis mer",
    "k3": "Laster inn eiendomsinnsikt...",
    "k4": "Feil:",
    "k5": "Eiendomsinnsikt (AI-generert)",
    "k6": "Ingen AI-generert innsikt tilgjengelig for denne eiendommen ennå.",
    "k7": "Detaljer:",
    "k8": "Kildeutdrag:",
    "k9": "Ekstrahert den:"
  },
  "propertyLeases": {
    "k1": "Laster inn leiekontrakter...",
    "k2": "Feil:",
    "k3": "Eiendomskontrakter",
    "k4": "Ingen leiekontrakter funnet for denne eiendommen.",
    "k5": "Leiekontrakt:",
    "k6": "System-ID:",
    "k7": "Leietaker:",
    "k8": "Startdato:",
    "k9": "Sluttdato:",
    "k10": "Leie:",
    "k11": "Vis",
    "k12": "Rediger",
    "k13": "Slett"
  },
  "propertyTypeChart": {
    "k1": "Antall eiendommer",
    "k2": "Eiendomsoversikt etter type"
  },
  "publicNavbar": {
    "k1": "CRE Dominion",
    "k2": "Hjem",
    "k3": "Live Screener",
    "k4": "Kunnskapsbase",
    "k5": "Kontakt",
    "k6": "Logg inn"
  },
  "quickActionsSection": {
    "k1": "Hurtighandlinger",
    "k2": "Legg til ny eiendom",
    "k3": "Legg til ny leiekontrakt",
    "k4": "Last opp dokument",
    "k5": "Onboarding",
    "k6": "Velkommen til CRE-Dominion!",
    "k7": "Følg disse enkle trinnene for å komme i gang:",
    "k8": "Legg til din første eiendom:",
    "k9": "Naviger til «Eiendommer»-seksjonen og klikk på «Legg til ny eiendom». Dette danner grunnlaget for all din eiendomsforvaltning.",
    "k10": "Last opp leiekontrakter:",
    "k11": "Når eiendommen er opprettet, gå til detaljsiden og last opp tilhørende leiekontrakter. Vår AI vil bistå med å abstrahere nøkkelinformasjon.",
    "k12": "Administrer dokumenter:",
    "k13": "Bruk «Dokumenter»-siden for å laste opp andre relevante filer, som finansielle rapporter eller markedsanalyser.",
    "k14": "Utforsk funksjoner:",
    "k15": "Dykk ned i \"Markedsreferanser\", \"Finansielle data\" og \"Kalender\" for å se hvordan CRE-Dominion kan effektivisere din forretningsdrift. Ikke nøl med å eksperimentere!",
    "k16": "Forstått!"
  },
  "recentActivitySection": {
    "k1": "Nylig aktivitet",
    "k2": "Ingen nylig aktivitet.",
    "k3": "Vis mer"
  },
  "summaryReportSection": {
    "k1": "Laster sammendragsrapport...",
    "k2": "Feil:",
    "k3": "Sammendragsrapport",
    "k4": "Totalt antall eiendommer",
    "k5": "Totalt antall leietakere",
    "k6": "Totalt antall dokumenter",
    "k7": "Gjennomsnittlig månedsleie"
  },
  "tenants": {
    "k1": "Laster leietakere...",
    "k2": "Feil:",
    "k3": "Leietakere",
    "k4": "Rediger leietaker",
    "k5": "Legg til ny leietaker",
    "k6": "Fornavn",
    "k7": "Etternavn",
    "k8": "E-post",
    "k9": "Telefonnummer",
    "k10": "Fødselsdato:",
    "k11": "Oppdater leietaker",
    "k12": "Legg til leietaker",
    "k13": "Avbryt redigering",
    "k14": "Dine leietakere",
    "k15": "Ingen leietakere funnet. Legg til en ovenfor!",
    "k16": "E-post:",
    "k17": "Telefon:",
    "k18": "Fødselsdato:",
    "k19": "Rediger",
    "k20": "Slett"
  },
  "termsOfService": {
    "k1": "&larr; Tilbake til forsiden",
    "k2": "Vilkår for bruk av CRE Dominion",
    "k3": "Velkommen til CRE Dominion. Disse vilkårene for bruk («Vilkårene») regulerer din tilgang til og bruk av CRE Dominion-nettstedet og tilhørende tjenester (samlet kalt «Tjenesten»). Ved å få tilgang til eller bruke Tjenesten, samtykker du i å være bundet av disse Vilkårene. Dersom du ikke aksepterer deler av vilkårene, kan du ikke benytte deg av Tjenesten.",
    "k4": "Brukerkontoer",
    "k5": "Når du oppretter en konto hos oss, må du til enhver tid oppgi informasjon som er nøyaktig, fullstendig og oppdatert. Unnlatelse av å gjøre dette utgjør et brudd på Vilkårene, noe som kan føre til umiddelbar oppsigelse av din konto i vår Tjeneste. Du er selv ansvarlig for å sikre passordet du bruker for å få tilgang til Tjenesten, samt for alle aktiviteter eller handlinger som utføres under ditt passord, uavhengig av om passordet er knyttet til vår Tjeneste eller en tredjepartstjeneste. Du samtykker i å ikke utlevere passordet ditt til tredjeparter. Du må varsle oss umiddelbart dersom du blir oppmerksom på sikkerhetsbrudd eller uautorisert bruk av din konto.",
    "k6": "Akseptabel bruk",
    "k7": "Du samtykker i å ikke bruke Tjenesten til ulovlige formål eller formål som er forbudt i henhold til disse Vilkårene. Du samtykker i å ikke bruke Tjenesten på en måte som kan skade, deaktivere, overbelaste eller svekke Tjenesten, eller forstyrre andre parters bruk og opplevelse av Tjenesten. Du kan ikke innhente eller forsøke å innhente materiale eller informasjon gjennom metoder som ikke er tilsiktet gjort tilgjengelig eller levert gjennom Tjenesten.",
    "k8": "Intellektuell eiendom",
    "k9": "Tjenesten og dens originale innhold (ekskludert innhold levert av brukere), funksjoner og funksjonalitet er og vil forbli den eksklusive eiendommen til CRE Dominion og dets lisensgivere. Tjenesten er beskyttet av opphavsrett, varemerkerett og andre lover i både USA og andre land. Våre varemerker og forretningskjennetegn kan ikke benyttes i forbindelse med produkter eller tjenester uten forutgående skriftlig samtykke fra CRE Dominion. Du beholder alle rettigheter til innhold du sender inn, publiserer eller viser på eller gjennom Tjenesten.",
    "k10": "Lenker til andre nettsteder",
    "k11": "Vår Tjeneste kan inneholde lenker til tredjepartsnettsteder eller tjenester som ikke eies eller kontrolleres av CRE Dominion. CRE Dominion har ingen kontroll over, og påtar seg intet ansvar for, innhold, personvernerklæringer eller praksis hos tredjepartsnettsteder eller tjenester. Du erkjenner og samtykker videre i at CRE Dominion ikke skal holdes ansvarlig, direkte eller indirekte, for skade eller tap som er forårsaket eller påstått å være forårsaket av, eller i forbindelse med, bruk av eller tillit til slikt innhold, varer eller tjenester tilgjengelig på eller gjennom slike nettsteder eller tjenester. Vi anbefaler på det sterkeste at du leser vilkårene og personvernerklæringene for alle tredjepartsnettsteder eller tjenester du besøker.",
    "k12": "Oppsigelse",
    "k13": "Vi kan avslutte eller suspendere din konto umiddelbart, uten forvarsel eller erstatningsansvar, uansett årsak, inkludert, men ikke begrenset til, dersom du bryter Vilkårene. Ved oppsigelse vil din rett til å bruke Tjenesten opphøre umiddelbart. Dersom du ønsker å avslutte din konto, kan du ganske enkelt slutte å bruke Tjenesten.",
    "k14": "Ansvarsfraskrivelse",
    "k15": "Din bruk av Tjenesten skjer på egen risiko. Tjenesten leveres på et «SOM DEN ER»- og «SOM TILGJENGELIG»-grunnlag. Tjenesten leveres uten garantier av noe slag, verken uttrykte eller underforståtte, inkludert, men ikke begrenset til, underforståtte garantier om salgbarhet, egnethet for et bestemt formål, ikke-krenkelse eller ytelsesforløp. CRE Dominion garanterer ikke at Tjenesten vil fungere uavbrutt, sikkert eller være tilgjengelig på et bestemt tidspunkt eller sted; at feil eller mangler vil bli rettet; at Tjenesten er fri for virus eller andre skadelige komponenter; eller at resultatene ved bruk av Tjenesten vil møte dine krav.",
    "k16": "Ansvarsbegrensning",
    "k17": "Under ingen omstendigheter skal CRE Dominion, eller dets styremedlemmer, ansatte, partnere, agenter, leverandører eller tilknyttede selskaper, holdes ansvarlige for indirekte, tilfeldige, spesielle, følgeskader eller straffeerstatninger, inkludert, men ikke begrenset til, tap av fortjeneste, data, bruk, goodwill eller andre immaterielle tap som følge av (i) din tilgang til, bruk av, eller manglende evne til å få tilgang til eller bruke tjenesten; (ii) enhver tredjeparts oppførsel eller innhold på tjenesten; (iii) innhold innhentet fra tjenesten; og (iv) uautorisert tilgang, bruk eller endring av dine overføringer eller innhold, enten basert på garanti, kontrakt, erstatningsrett (inkludert uaktsomhet) eller enhver annen juridisk teori, uavhengig av om vi har blitt informert om muligheten for slik skade, og selv om et rettsmiddel angitt heri viser seg å ha feilet sitt vesentlige formål.",
    "k18": "Gjeldende lov",
    "k19": "Disse vilkårene skal reguleres og tolkes i samsvar med lovgivningen i delstaten California, USA, uten hensyn til dens prinsipper om lovvalg. Vår unnlatelse av å håndheve enhver rettighet eller bestemmelse i disse vilkårene skal ikke anses som et avkall på slike rettigheter. Dersom en bestemmelse i disse vilkårene blir funnet ugyldig eller ikke rettskraftig av en domstol, skal de gjenværende bestemmelsene i disse vilkårene forbli i kraft. Disse vilkårene utgjør hele avtalen mellom oss vedrørende vår tjeneste og erstatter alle tidligere avtaler vi måtte ha hatt mellom oss vedrørende tjenesten.",
    "k20": "Endringer i vilkår",
    "k21": "Vi forbeholder oss retten til, etter eget skjønn, å endre eller erstatte disse vilkårene når som helst. Dersom en revisjon er vesentlig, vil vi forsøke å gi minst 30 dagers varsel før nye vilkår trer i kraft. Hva som utgjør en vesentlig endring vil bli bestemt etter vårt eget skjønn. Ved å fortsette å få tilgang til eller bruke vår tjeneste etter at slike revisjoner trer i kraft, samtykker du i å være bundet av de reviderte vilkårene. Hvis du ikke godtar de nye vilkårene, vennligst slutt å bruke tjenesten.",
    "k22": "Kontakt oss",
    "k23": "Hvis du har spørsmål om disse vilkårene, vennligst kontakt oss på support@credominion.com."
  },
  "underwritingToolkit": {
    "k1": "Verktøykasse for transaksjonsanalyse",
    "k2": "Eiendom- og finansieringsdata",
    "k3": "Kjøpesum",
    "k4": "Brutto årlig leieinntekt",
    "k5": "Andre årlige inntekter (f.eks. parkering, vaskeri)",
    "k6": "Ledighetsrate (%)",
    "k7": "Årlige driftskostnader",
    "k8": "Årlige investeringsutgifter (CapEx)",
    "k9": "Lånebeløp",
    "k10": "Rentesats (%)",
    "k11": "Lånetid (år)",
    "k12": "Etableringskostnader (%)",
    "k13": "Nøkkeltall for ytelse",
    "k14": "Effektiv bruttoinntekt",
    "k15": "Netto driftsresultat (NOI)",
    "k16": "Cap Rate",
    "k17": "Total investert egenkapital",
    "k18": "Årlig gjeldsbetjening",
    "k19": "Årlig kontantstrøm",
    "k20": "Cash-on-Cash avkastning",
    "k21": "Gjeldsbetjeningsgrad (DSCR)",
    "k22": "Brutto leiemultiplikator (GRM)",
    "k23": "Belåningsgrad (LTV)"
  },
  "upcomingPaymentsSection": {
    "k1": "Kommende betalinger (30 dager)",
    "k2": "Forfall:",
    "k3": "Leieavtale-ID:",
    "k4": "Ingen kommende betalinger."
  },
  "vacancyRateChart": {
    "k1": "Trender for ledighetsgrad"
  },
  "valuation": {
    "k1": "&larr; Tilbake til eiendommer",
    "k2": "Verdivurdering av eiendom",
    "k3": "Sammenlignbare salg",
    "k4": "Avkastningsmetoden",
    "k5": "Diskontert kontantstrøm (DCF)",
    "k6": "Kostnadsmetoden",
    "k7": "Henter verdivurdering...",
    "k8": "Hent verdivurdering",
    "k9": "Lagre resultat",
    "k10": "Laster inn verdivurdering...",
    "k11": "Verdivurdering for eiendom",
    "k12": "Sammendrag av verdivurdering:",
    "k13": "Endelig anbefalt verdi:",
    "k14": "Dato for verdivurdering:",
    "k15": "Verdivurderingsmetode:",
    "k16": "Forutsetninger:",
    "k17": "Ansvarsfraskrivelse:",
    "k18": "Detaljer om verdivurdering:"
  },
  "articleCard": {
    "k1": "Publisert:",
    "k2": "Les mer"
  },
  "leaseInsightWidget": {
    "k1": "Umiddelbar AI-innsikt for næringseiendom",
    "k2": "Analyser leieavtaler, finansielle rapporter eller markedsanalyser umiddelbart.",
    "k3": "Lim inn klausul eller sammendrag",
    "k4": "f.eks. 'Leietaker skal ha rett til å si opp denne leieavtalen dersom utleier unnlater å levere...'",
    "k5": "Endre dokument",
    "k6": "Last opp PDF/Doc",
    "k7": "Støtter PDF opptil 5MB",
    "k8": "Utfør analyse nå →",
    "k9": "Prosesserer intelligens...",
    "k10": "Prøveperiode utløpt",
    "k11": "Opprett gratis arbeidsområde →",
    "k12": "Tilbake til widget",
    "k13": "Konfidensnivå:",
    "k14": "Nullstill",
    "k15": "Ledelsessammendrag",
    "k16": "Strategisk handlingsplan",
    "k17": "Lås opp profesjonell porteføljeanalyse →"
  },
  "bottomCTA": {
    "k1": "Slutt å la penger",
    "k2": "ligge igjen på bordet.",
    "k3": "Bli med over 500+ CRE-profesjonelle som bruker AI til å automatisere abstraksjon, finne off-market-avtaler og maksimere porteføljens ROI.",
    "k4": "Kom i gang gratis →",
    "k5": "Ingen kredittkort kreves"
  },
  "insufficientCreditsModal": {
    "k1": "Kreditter oppbrukt",
    "k2": "Du har brukt opp dine aktive kreditter. Fyll på nå for å låse opp ubegrenset AI-leieavtaleabstraksjon, prediktiv analyse og automatiserte verktøy for underwriting.",
    "k3": "Umiddelbar leieavtaleabstraksjon",
    "k4": "Ekstraher nøkkelvilkår og finansielle detaljer umiddelbart.",
    "k5": "Underwriting-verktøykasse",
    "k6": "Generer granulære verdivurderinger og prognostiser avkastning.",
    "k7": "Prediktiv trendprognose",
    "k8": "Simuler geografiske og prismessige skift over tid.",
    "k9": "Markedsanalyse-motor",
    "k10": "Kjør sammenlignbare analyser (comps) og makroevalueringer.",
    "k11": "Kjøp kredittpakker",
    "k12": "Få 125 kreditter for $50 for å fortsette behandlingen av avtaler.",
    "k13": "Hent kreditter"
  },
  "contact": {
    "k1": "Kontakt CRE Dominion | Institusjonell plattform for næringseiendom",
    "k2": "Kontakt CRE Dominion",
    "k3": "CRE Dominion",
    "k4": "Direkte assistanse",
    "k5": "Har du spørsmål om AI-leieavtaleabstraksjon, verdivurderingsarbeidsflyter eller integrasjoner for bedriftsporteføljer? Vårt team av eiendomsteknologer er her for å hjelpe.",
    "k6": "Kunde- og teknisk støtte",
    "k7": "For kontospørsmål, verifisering av leieavtaleabstraksjon og teknisk assistanse.",
    "k8": "SLA: Under 4 virketimer",
    "k9": "Forespørsel sendt",
    "k10": "Takk for at du kontakter CRE Dominion. Din henvendelse er videresendt til",
    "k11": ". Hvis e-postklienten din ikke åpnet seg automatisk, klikk nedenfor for å verifisere eller sende fra din foretrukne e-postklient.",
    "k12": "Åpne i e-postapp",
    "k13": "Send en ny melding",
    "k14": "Send en forespørsel",
    "k15": "Fullt navn *",
    "k16": "Sarah Connor",
    "k17": "E-post (jobb) *",
    "k18": "Selskap / Portefølje",
    "k19": "Apex Asset Management",
    "k20": "Type forespørsel",
    "k21": "Generell support",
    "k22": "Enterprise-lisensiering",
    "k23": "API-integrasjon",
    "k24": "Fakturering og abonnement",
    "k25": "Sikkerhet og samsvar",
    "k26": "Melding *",
    "k27": "Vennligst beskriv dine porteføljebehov, eiendomsvolumer eller tekniske spørsmål...",
    "k28": "Beskyttet av TLS 1.3-kryptering. Vi deler aldri dine kommersielle data.",
    "k29": "Send forespørsel",
    "k30": "Ofte stilte spørsmål &rarr;",
    "k31": "Personvernerklæring",
    "k32": "Tjenestevilkår",
    "k33": "CRE Knowledge Hub"
  },
  "instantUnderwritingWidget": {
    "k1": "⚡ Interaktiv underwriting-screener",
    "k2": "Ingen pålogging kreves",
    "k3": "Institusjonell CRE-underwriting og avkastningsmodellering",
    "k4": "Veksle mellom amerikanske, britiske og europeiske eiendomsstandarder. Umiddelbar matematisk verifisering av avtalemetrikker.",
    "k5": "🇺🇸 USA",
    "k6": "🇬🇧 Storbritannia",
    "k7": "🇪🇺 Norden og Europa",
    "k8": "Europeisk valuta:",
    "k9": "kr",
    "k10": "I samsvar med nordisk KPI-indeksering og metriske standarder (`m²`)",
    "k11": "Raske aktivaforslag:",
    "k12": "🏢 Kontoreiendom",
    "k13": "🏭 Logistikk / Industri",
    "k14": "🏬 Kombinasjonseiendom / Boligseksjon",
    "k15": "Kjøpesum / Verdivurdering (",
    "k16": "Brutto leieinntekter / år (",
    "k17": "Totalt utleibart areal (",
    "k18": "Ledighetsrate (%)",
    "k19": "Driftskostnader / år (",
    "k20": "Forutsetninger for gjeld og finansiering",
    "k21": "Belåningsgrad (LTV) (",
    "k22": "Rentenivå (",
    "k23": "Avdragstid (",
    "k24": "år)",
    "k25": "Umiddelbar avkastningsprofil",
    "k26": "Verifisert formel",
    "k27": "Netto driftsresultat (NOI)",
    "k28": "Kontantavkastning (Cash-on-Cash)",
    "k29": "Gjeldsbetjeningsevne (DSCR)",
    "k30": "Kontantkjøp",
    "k31": "Brutto direkteavkastning",
    "k32": "Årlig kontantstrøm",
    "k33": "Enhetsleie:",
    "k34": "/ år",
    "k35": "Egenkapital:",
    "k36": "Lagre transaksjon og eksporter teaser (Gratis)",
    "k37": "Inkluderer 125 gratis startkreditter ved registrering. Ingen kredittkort kreves."
  },
  "articleDetailPage": {
    "k1": "Feil:",
    "k2": "Artikkelen ble ikke funnet.",
    "k3": "CRE Dominion",
    "k4": "Tilbake til kunnskapsbase",
    "k5": "• Publisert",
    "k6": "Om forfatteren",
    "k7": "Til toppen",
    "k8": "Les flere artikler"
  },
  "blogListPage": {
    "k1": "Laster inn bloggartikler...",
    "k2": "Feil:",
    "k3": "Kunnskapsbase - Ekspertinnsikt i næringseiendom | CRE Dominion",
    "k4": "Kunnskapsbase",
    "k5": "Forrige side",
    "k6": "Forrige",
    "k7": "Neste side",
    "k8": "Neste",
    "k9": "Ingen bloggartikler tilgjengelig ennå. Følg med!"
  },
  "adminSEOPage": {
    "k1": "Laster inn SEO-kontrollpanel...",
    "k2": "Feil:",
    "k3": "Kontrollpanel for SEO-automatisering",
    "k4": "Genererte artikler",
    "k5": "Ingen artikler generert ennå."
  },
  "demoPage": {
    "badge": "60-sekunders interaktiv sandkasse",
    "title": "Næringsleieabstraksjon og CAM-revisjon på sekunder",
    "subtitle": "Automatisk revisjon av næringsleieavtaler, CAM-avstemmingsgrenser, KPI-indeksklausuler og leieavvik fra lange PDF-leieavtaler.",
    "step1Title": "Dokumentopplasting",
    "step1Desc": "Last opp 50+ siders leiekontrakter eller lim inn komplekse CAM- og KPI-eskaleringsklausuler.",
    "step2Title": "AI-klausulabstraksjon",
    "step2Desc": "Gemini 3.8 Flash henter ut basisleie, driftsutgiftsstopp, CAM-tak, indeksdatoer og revisjonsvinduer.",
    "step3Title": "Revisjonstabell og risikoer",
    "step3Desc": "Varsler om overfakturering, kumulative CAM-feller og tapte indeksjusteringer.",
    "widgetHeader": "Interaktiv leieklausulanalysator",
    "widgetSub": "Lim inn en leieklausul eller last opp et PDF-utdrag under for sanntidsekstraksjon.",
    "liveBadge": "Live backend-endepunkt",
    "whyTitle": "Hvorfor eiendomsforvaltere stoler på CRE-Dominion",
    "benefit1Title": "1. Null manuell leiedataføring",
    "benefit1Desc": "Gjør 80-siders leiekontrakter om til verifiserte sammendrag på 30 sekunder i stedet for 4 timer.",
    "benefit2Title": "2. Fang opp CAM-overpriser",
    "benefit2Desc": "Kryssjekk kontrollerbare mot ikke-kontrollerbare utgiftstak før godkjenning av årlig avregning.",
    "benefit3Title": "3. Automatiserte KPI-justeringar",
    "benefit3Desc": "Gå aldri glipp av en årlig inflasjonsjustering eller frist i din næringseiendomsportefølje.",
    "ctaText": "Klar til å teste CRE-Dominion på din egen portefølje?",
    "ctaBtn": "Start gratis 14-dagers pilot ->",
    "signIn": "Logg inn",
    "requestPilot": "Be om pilot"
}
,
  "about": {
    "pageTitle": "Om oss & Ledarskap | CRE-Dominion Kommersiell Eiendomsintelligens",
    "navHome": "Hjem",
    "navResearch": "Forskning",
    "navContact": "Kontakt",
    "navSignIn": "Logg inn",
    "navPilot": "Be om pilot",
    "heroBadge": "Institusjonell kommersiell eiendomsintelligens",
    "heroTitle": "Arkitekturert for institusjonelle forvaltere & meglere",
    "heroSubtitle": "CRE-Dominion automatiserer kommersiell leiekontraktabstraksjon, felleskostnadsavstemming og algoritmisk avtaleanalyse. Vi fjerner manuell friksjon slik at eiendomsaktører lukker avtaler med empirisk presisjon.",
    "pillar1Title": "Automatisert kontraktabstraksjon",
    "pillar1Desc": "Trekk ut leieplaner, indeksreguleringer, opsjoner og kritiske utløpsfrister fra 80+ siders leiekontrakter på sekunder.",
    "pillar2Title": "Prediktiv underwriting & analyse",
    "pillar2Desc": "Algoritmisk verdsettelsesmotor som dynamisk stresstester yield, driftsnetto og gjeldsbetjeningsevne mot markedsdata i sanntid.",
    "pillar3Title": "Sikkerhet i bankklasse",
    "pillar3Desc": "Streng kryptografisk flerleie-isolering. Deres proprietære leietakerlister, kontrakter og proformaer brukes aldri til modelltrening.",
    "founderLeadership": "Lederskap",
    "founderName": "Ghazwan Alemara",
    "founderRole": "Grunnlegger & Lead Systems Architect · CRE-Dominion",
    "founderSub": "støttet av Data Genius",
    "founderLinkedIn": "Koble til på LinkedIn",
    "founderBio1": "Ghazwan Alemara er grunnlegger og Lead Systems Architect for CRE-Dominion, støttet av forsknings- og programvarestudioet Data Genius. Med bakgrunn innen storskala systemarkitektur og kvantitativ programvareutvikling utviklet Ghazwan CRE-Dominion for å fjerne informasjonsasymmetrien innen kommersiell eiendomsforvaltning og transaksjonsanalyse.",
    "founderBio2": "Med en mastergrad (M.Sc.) i systemvitenskap fra Stockholms universitet (EQF-nivå 7) anvender han deterministiske beregningsmodeller for å erstatte manuelle regneark med algoritmisk analyse og automatisert revisjon.",
    "card1Label": "Utdanning",
    "card1Val": "M.Sc. Systemvitenskap",
    "card1Sub": "Stockholms universitet (EQF 7)",
    "card2Label": "Arkitektur",
    "card2Val": "Lead Systems Architect",
    "card2Sub": "Algoritmisk eiendomsintelligens",
    "card3Label": "Utviklingsstudio",
    "card3Val": "Data Genius",
    "card3Sub": "Anvendt systemutvikling",
    "card4Label": "Dataforsvar",
    "card4Val": "Zero-Trust-isolering",
    "card4Sub": "Institusjonelt personvern",
    "ctaTitle": "Ta i bruk CRE-Dominion for din eiendomsportefølje",
    "ctaDesc": "Opplev 60-sekunders kontraktabstraksjon og institusjonell deal-underwriting på dine aktive prosjekter med vårt pilotprogram.",
    "ctaBtn": "Be om institusjonell pilot",
    "ctaDemo": "Utforsk 60-sekunders demo",
        "secBadge": "Bankkonfidensialitet & Datasuverenitet",
    "secTitle": "Institusjonell sikkerhet & nulltillitsvern",
    "secSub": "Utviklet spesifikt for institusjonelle eiendomsforvaltere, fond og næringsmeglere med konfidensielle transaksjonsdata.",
    "secCard1Title": "Ingen AI-modelltrening",
    "secCard1Desc": "Dine leiekontrakter, leietakerlister og analysedata holdes strengt isolert. Vi trener aldri globale AI-modeller på kundedata.",
    "secCard2Title": "AES-256 & TLS 1.3-kryptering",
    "secCard2Desc": "All dokumentprosessering og finansielle data krypteres under overføring og lagring med automatisk filopprydding.",
    "secCard3Title": "Streng leietakerisolering",
    "secCard3Desc": "Strenge IAM-tilgangsbarrierer på arbeidsområdenivå. Null lekkasje mellom organisasjoner, med garantert transaksjonsdiskresjon.",
    "secCard4Title": "SOC-2 & GDPR-tilpasset arkitektur",
    "secCard4Desc": "Full overholdelse av europeiske datastyringsstandarder, uforanderlige revisjonslogger og full datasuverenitet.",
    "pilotBadge": "Institusjonell risikoreduksjon",
    "pilotTitle": "14-dagers institusjonelt pilotrammeverk",
    "pilotSub": "Evaluer CRE-Dominion risikofritt på dine aktive næringseiendommer før full organisasjonsrulling.",
    "pilotStep1Title": "1. Empirisk leieavtalebenchmark",
    "pilotStep1Desc": "Last opp 5-10 av dine mest komplekse leieavtaler. Test uttrekkshastighet, felleskostnadsberegninger og nøyaktighet mot interne referanser.",
    "pilotStep2Title": "2. Tilpasset analyseinnstilling",
    "pilotStep2Desc": "Vi kalibrerer verdsettelsesalgoritmer, DCF-avkastningskrav og kontantstrømrapporter etter investeringskomiteens retningslinjer.",
    "pilotStep3Title": "3. Direkte ingeniør-SLA",
    "pilotStep3Desc": "Direktelinje til sjefarkitekt Ghazwan Alemara, garantert under 60 sekunders prosesseringstid og prioritert systemintegrasjon.",
    "footerRights": "CRE-Dominion · Et Data Genius-selskap. Alle rettigheter reservert."
}
};
